import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronDownIcon} from '@/components/ui/icon/Icon'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {Text} from '@/components/ui/text/Text'
import {useToggle} from '@/hooks/useToggle'
import {MessageCard} from '@/components/commons/message-card/MessageCard'
import {ReactNode} from 'react'

interface AccordionErrorProps {
    title: string
    description?: ReactNode
}

export const AccordionError = ({title, description}: AccordionErrorProps) => {
    const {toggle, isActive: isErrorDetailsOpen} = useToggle(false)
    return (
        <Flexbox direction="column" gap={2}>
            <Flexbox gap={2} align="center">
                <Text size="textMd" palette="danger" shade="700">
                    {title}
                </Text>
                {description && (
                    <Button variant="tertiary" size="xs" shape="square" onClick={toggle}>
                        <ChevronDownIcon
                            size={16}
                            style={{transform: isErrorDetailsOpen ? 'rotate(180deg)' : 'rotate(0deg)'}}
                        />
                    </Button>
                )}
            </Flexbox>
            {description && isErrorDetailsOpen && (
                <MessageCard>
                    <ScrollArea scrollbar={<Scrollbar />} viewportProps={{style: {height: '80px'}}}>
                        {typeof description == 'string' ? (
                            <Text size="textSm" palette="danger" shade="900">
                                {description}
                            </Text>
                        ) : (
                            description
                        )}
                    </ScrollArea>
                </MessageCard>
            )}
        </Flexbox>
    )
}
